/**
 * Include your custom JavaScript here.
 */

/* === MHH — reveal-on-scroll para cartões de produto (à prova de falhas) === */
(function () {
  function init() {
    if (!('IntersectionObserver' in window)) return; // sem suporte: deixa visível
    var vh = window.innerHeight || 800;
    var items = Array.prototype.slice.call(document.querySelectorAll('.product-item'));
    var toObserve = [];

    items.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9) return; // já visível: não esconder
      el.style.opacity = '0';
      el.style.transition = 'opacity .6s cubic-bezier(.2,.7,.2,1)';
      el.style.willChange = 'opacity';
      toObserve.push(el);
    });

    if (!toObserve.length) return;

    function reveal(el) { el.style.opacity = '1'; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });

    toObserve.forEach(function (el) { io.observe(el); });

    // failsafe: nunca deixar nada escondido
    setTimeout(function () { toObserve.forEach(reveal); }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* === MHH #AN-3 — barra sticky "adicionar ao carrinho" === */
(function () {
  function initATC() {
    var bar = document.getElementById('mhh-atc');
    if (!bar) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    var btn = document.getElementById('mhh-atc-btn');
    if (btn && form) {
      btn.addEventListener('click', function () {
        var real = form.querySelector('[type="submit"], button:not([type="button"])');
        if (real) { real.click(); }
        else if (form.requestSubmit) { form.requestSubmit(); }
        else { form.submit(); }
      });
    }
    if (form && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
      }, { threshold: 0 });
      io.observe(form);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initATC);
  } else {
    initATC();
  }
})();

/* === MHH — extras de confiança na página de produto (sob o botão de compra) === */
(function () {
  function initPDP() {
    var tpl = document.getElementById('mhh-pdp-tpl');
    if (!tpl || !tpl.content) return;
    if (document.querySelector('.mhh-pdp')) return;
    var anchor = document.querySelector('.product-form__payment-container');
    if (!anchor) return;
    anchor.parentNode.insertBefore(tpl.content.cloneNode(true), anchor.nextSibling);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPDP);
  } else {
    initPDP();
  }
})();

/* === MHH — seletor de idioma: dropdown por clique, percetível, funciona em mobile === */
(function () {
  function inject() {
    // 1) CSS: abrir por .open (em vez de :hover), visível em mobile, botão mais percetível; + limpeza do nav
    if (!document.getElementById('mhh-lang-css')) {
      var css = ''
        + '.mhh-langmenu{opacity:0 !important;visibility:hidden !important;transform:translateY(4px) !important;transition:opacity .16s ease,transform .16s ease,visibility 0s .16s !important}'
        + '.mhh-langdd.open .mhh-langmenu{opacity:1 !important;visibility:visible !important;transform:translateY(0) !important;transition:opacity .16s ease,transform .16s ease,visibility 0s !important}'
        + '.mhh-langcar{transition:transform .2s ease !important}'
        + '.mhh-langdd:hover .mhh-langcar{transform:none !important}'
        + '.mhh-langdd.open .mhh-langcar{transform:rotate(180deg) !important}'
        + '.mhh-langbtn{padding:6px 12px !important;gap:7px !important;border-color:rgba(255,255,255,.32) !important}'
        + '.mhh-langbtn:hover,.mhh-langdd.open .mhh-langbtn{color:#fff !important;border-color:#fff !important;background:rgba(255,255,255,.07) !important}'
        + '.mhh-langglobe{flex:none;opacity:.9}'
        + '.mhh-navlink,.mhh-deals{white-space:nowrap !important}'
        + '.mhh-nav>a[href$="colunas-portateis-bluetooth-e-wi-fi"],.mhh-nav>a[href$="auscultadores-headphones-auriculares-hi-fi"]{display:none !important}'
        + '@media(max-width:1200px){.mhh-nav{gap:16px !important;font-size:13px !important}}'
        + '@media(max-width:760px){.mhh-langmenu{right:0 !important;min-width:172px !important}}';
      var s = document.createElement('style');
      s.id = 'mhh-lang-css';
      s.textContent = css;
      document.head.appendChild(s);
    }
    // 2) Ícone de globo (torna o seletor percetível) — antes do código do idioma
    var btn = document.querySelector('.mhh-langbtn');
    if (btn && !btn.querySelector('.mhh-langglobe')) {
      var NS = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'mhh-langglobe');
      svg.setAttribute('width', '15'); svg.setAttribute('height', '15');
      svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '1.7');
      var c = document.createElementNS(NS, 'circle');
      c.setAttribute('cx', '12'); c.setAttribute('cy', '12'); c.setAttribute('r', '9');
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', 'M3 12h18M12 3c2.4 2.6 3.7 5.8 3.7 9s-1.3 6.4-3.7 9c-2.4-2.6-3.7-5.8-3.7-9s1.3-6.4 3.7-9z');
      svg.appendChild(c); svg.appendChild(p);
      btn.insertBefore(svg, btn.firstChild);
    }
    // 3) Nome do idioma sem o país entre parênteses: "Português (Portugal)" -> "Português"
    var names = document.querySelectorAll('.mhh-langitem__name');
    for (var i = 0; i < names.length; i++) {
      names[i].textContent = names[i].textContent.replace(/\s*\(.*\)\s*$/, '');
    }
    // 4) Mostrar apenas PT + EN no seletor (DE/ES/FR ainda não traduzidos) — desktop + drawer
    var keep = ['PT', 'EN'];
    var lgitems = document.querySelectorAll('.mhh-langitem');
    for (var j = 0; j < lgitems.length; j++) {
      var codeEl = lgitems[j].querySelector('.mhh-langitem__code');
      var t1 = (codeEl ? codeEl.textContent : lgitems[j].textContent) || '';
      if (keep.indexOf(t1.trim().toUpperCase()) < 0) { lgitems[j].style.display = 'none'; }
    }
    var lglinks = document.querySelectorAll('.mhh-lang');
    for (var k = 0; k < lglinks.length; k++) {
      var t2 = (lglinks[k].textContent || '').trim().toUpperCase();
      if (keep.indexOf(t2) < 0) { lglinks[k].style.display = 'none'; }
    }
  }

  function close(d) {
    d.classList.remove('open');
    var b = d.querySelector('.mhh-langbtn');
    if (b) { b.setAttribute('aria-expanded', 'false'); }
  }

  function wire() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.mhh-langbtn') : null;
      if (btn) {
        var dd = btn.parentNode;
        var isOpen = dd.classList.toggle('open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.querySelectorAll('.mhh-langdd.open').forEach(function (d) { if (d !== dd) close(d); });
        e.stopPropagation();
        return;
      }
      document.querySelectorAll('.mhh-langdd.open').forEach(function (d) { if (!d.contains(e.target)) close(d); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { document.querySelectorAll('.mhh-langdd.open').forEach(close); }
    });
  }

  function start() { inject(); wire(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* === MHH — remover bloco "The brands / As marcas" das descrições de coleção (versão EN; PT já está limpo) === */
(function () {
  function cleanBrands() {
    if (!/\/collections\//.test(location.pathname)) return; // só em páginas de coleção
    var heads = document.querySelectorAll('h2');
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      var links = h.querySelectorAll('a[href*="/collections/"]');
      if (links.length >= 2) { // é a lista de marcas
        var prev = h.previousElementSibling;
        // remove parágrafos anteriores tipo "The brands:" ou vazios
        while (prev && prev.tagName === 'P' &&
               (/^\s*(the brands|as marcas)/i.test(prev.textContent) || /^[\s ]*$/.test(prev.textContent))) {
          var rm = prev; prev = prev.previousElementSibling; rm.remove();
        }
        h.remove();
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanBrands);
  else cleanBrands();
})();
